export const UploadFileSize = 8 * 1024 * 1024;

export enum UploadDocumentConstant {
  ERROR_MSG_1 = 'File size should not be more than 8 MB',
  ERROR_MSG_2 = 'Uploaded file is not a valid image file.',
  ERROR_MSG_3 = 'File not found',
  LOGGER_MSG_1 = 'Insurance Removal Done !',
  LOGGER_MSG_2 = '401 error - retry uploading',
  IMG_ACCEPT_PATH = 'image/*',
  DOCUMENT_ID = 'documentId',
  FAILURE_REASON = 'failureReason',
  IS_UPLOADED = 'isUploaded',
  POST = 'POST',
  ACCESS_TOKEN = 'access_token',
  T2FA = 't2fa',
  APPLICATION_JSON = 'application/json',
  CONTENT_TYPE = 'Content-Type',
  MINUS_ONE = '-1',
  IMAGE_NAME = 'image.png',
  DONE = 'done',
}
